module.exports = __webpack_public_path__ + "static/media/cutting.b87f50ed.mp4";